import React from 'react';

import PropTypes from 'prop-types';

import { BlockContainer } from './css';
import BlockItem from './components/blockItem';

const Block = ({ data, filterString, fetchData }) => {
  let filteredData = [...data];
  if (filterString)
    filteredData = data.filter(({ name }) => {
      const searchIn = name.toLowerCase();
      const searchFor = filterString.toLowerCase();
      return searchIn.includes(searchFor);
    });

  return (
    <BlockContainer>
      {filteredData.map(rowData => (
        <BlockItem key={rowData.id} data={rowData} fetchData={fetchData} />
      ))}
    </BlockContainer>
  );
};

Block.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      formTypes: PropTypes.shape({
        disableBrp: PropTypes.bool,
        disableReferral: PropTypes.bool,
        disableWireless: PropTypes.bool,
        disableWireline: PropTypes.bool
      })
    })
  ).isRequired,
  filterString: PropTypes.string.isRequired,
  fetchData: PropTypes.func.isRequired
};

export default Block;
